export const iconFontAwesomeMapsMugSaucer = (
	<i className="fa-solid fa-mug-saucer"></i>
);
